import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { provideNgxMask } from 'ngx-mask';
import { Masks, MaskService } from '../../../shared/services/mask.service';
import { UsuarioAdminLookupResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-lookup.response';
import { CategoriaArquivoService } from '../../../shared/services/apis/integracao-arquivos/categoria-arquivo.service';
import { CategoriaArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/categoria-arquivo.response';
import { CategoriaArquivoRequest } from '../../../shared/services/requests/integracao-arquivos/categoria-arquivo.request';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TagArquivo } from '../../../shared/services/models/integracao-arquivos/tag-arquivo.model';
import { ListaTagArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/lista-tag-arquivo.response';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';

@Component({
  selector: 'app-categoria-arquivo-cadastro',
  imports: [
    MenuComponent,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatChipsModule,
  ],
  providers: [provideNgxMask()],
  templateUrl: './categoria-arquivo-cadastro.component.html',
  styleUrl: './categoria-arquivo-cadastro.component.css',
})
export class CategoriaArquivoCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  public model: FormGroup;
  public _isLoading: boolean = false;
  public _usuarioLookupResponse: UsuarioAdminLookupResponse;
  public _categoriaArquivoResponse: CategoriaArquivoResponse;
  public _listaTagArquivoPorCategoria: TagArquivo[] = [];
  public idCategoriaArquivo: number | null = null;
  public nomeEmpresaLogada: string;
  public masks: Masks;

  // Propriedades para o controle da tag de arquivo (Chip com Autocomplete)
  public validaListaTagArquivo = (): { required: boolean } | null => {
    return this._listaTagArquivoPorCategoria?.length > 0 ? null : { required: true };
  };
  public formControlTagArquivo = new FormControl('', [this.validaListaTagArquivo]);
  public separatorKeysCodesTagArquivo: number[] = [ENTER, COMMA];

  constructor(
    private formBuilder: FormBuilder,
    private categoriaArquivoService: CategoriaArquivoService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private maskService: MaskService
  ) {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
    this.funcionalidadeEnum = FuncionalidadeEnum.Desenvolvedor_CategoriaArquivo;
  }

  ngOnInit(): void {
    this.masks = this.maskService.getMasks();

    if (this.activatedRoute.snapshot.paramMap.get('idCategoriaArquivo')) {
      this.idCategoriaArquivo = parseInt(
        this.activatedRoute.snapshot.paramMap.get('idCategoriaArquivo') ?? ''
      );
    }

    this.model = this.formBuilder.group({
      nome: new FormControl('', [Validators.required, requiredTrim]),
      tagArquivo: this.formControlTagArquivo,
      observacao: new FormControl('', [Validators.required, requiredTrim]),
    });

    if (this.idCategoriaArquivo && this.idCategoriaArquivo > 0) {
      this.popularLookup();
      this.popularDadosCategoria(this.idCategoriaArquivo);
      this._isLoading = false;
    }
  }

  popularLookup(): void {
    this.categoriaArquivoService.lookupListaTagArquivo().subscribe({
      next: (response: ListaTagArquivoResponse) => {
        if (!response.isError) {
          this._listaTagArquivoPorCategoria = response.listaTagArquivo.filter(
            tag => tag.idCategoriaArquivo === this.idCategoriaArquivo
          );
          this.formControlTagArquivo.updateValueAndValidity();
        }
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  // Exibe o nome da tag no input do autocomplete
  displayTag(tag: TagArquivo): string {
    return tag && tag.nome ? tag.nome : '';
  }

  removeTagArquivo(idTagArquivo: number): void {
    const index = this._listaTagArquivoPorCategoria.findIndex(
      tagArquivo => tagArquivo.idTagArquivo === idTagArquivo
    );

    if (index > -1) {
      this._listaTagArquivoPorCategoria.splice(index, 1);
    }
  }

  addTagArquivo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Regex: aceita apenas letras e números
    const regex = /^[a-zA-Z0-9_-]+$/;

    if (value && regex.test(value) && value.trim() !== '-') {
      const tagArquivo = new TagArquivo();
      tagArquivo.nome = value;
      tagArquivo.idTagArquivo = this._listaTagArquivoPorCategoria.length + 1;

      if (this.idCategoriaArquivo) {
        tagArquivo.idCategoriaArquivo = this.idCategoriaArquivo;
      }

      this._listaTagArquivoPorCategoria.push(tagArquivo);
    } else {
      this.alertService.show('Erro', 'Somente letras e números são permitidos.', AlertType.warning);
    }

    event.chipInput!.clear();
  }

  submit(): void {
    if (this._isLoading || this.model.invalid) {
      return;
    }

    this._listaTagArquivoPorCategoria.forEach(tag => {
      tag.idTagArquivo = 0;
    });

    if (!this.idCategoriaArquivo) {
      const categoriaArquivoRequest: CategoriaArquivoRequest = new CategoriaArquivoRequest();
      categoriaArquivoRequest.nome = this.model.get('nome')?.value;
      categoriaArquivoRequest.listaTagArquivo = this._listaTagArquivoPorCategoria;
      categoriaArquivoRequest.observacao = this.model.get('observacao')?.value;
      this.novo(categoriaArquivoRequest);
    } else {
      const categoriaArquivoRequest: CategoriaArquivoRequest = new CategoriaArquivoRequest();
      categoriaArquivoRequest.idCategoriaArquivo = this.idCategoriaArquivo;
      categoriaArquivoRequest.nome = this.model.get('nome')?.value;
      categoriaArquivoRequest.listaTagArquivo = this._listaTagArquivoPorCategoria;
      categoriaArquivoRequest.observacao = this.model.get('observacao')?.value;
      this.alterar(this.idCategoriaArquivo, categoriaArquivoRequest);
    }
  }

  private novo(categoriaArquivoRequest: CategoriaArquivoRequest): void {
    this._isLoading = true;
    this.categoriaArquivoService.incluir(categoriaArquivoRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Categoria incluída com sucesso.', AlertType.success);
        this.router.navigate(['/desenvolvedor/categoria-arquivo']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  popularDadosCategoria(idCategoriaArquivo: number): void {
    this._isLoading = true;
    this.categoriaArquivoService.pesquisaCategoriaPorId(idCategoriaArquivo).subscribe({
      next: (categoriaArquivoResponse: CategoriaArquivoResponse) => {
        if (categoriaArquivoResponse.isError) {
          this.alertService.show('Erro', categoriaArquivoResponse.errorDescription, AlertType.error);
          return;
        }

        this.model.get('nome')?.setValue(categoriaArquivoResponse.categoriaArquivo.nome);
        this.model.get('observacao')?.setValue(categoriaArquivoResponse.categoriaArquivo.observacao);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private alterar(idCategoriaArquivo: number, categoriaArquivoRequest: CategoriaArquivoRequest): void {
    this._isLoading = true;
    this.categoriaArquivoService.alterar(idCategoriaArquivo, categoriaArquivoRequest).subscribe({
      next: (categoriaArquivoResponse: CategoriaArquivoResponse) => {
        this._isLoading = false;
        if (categoriaArquivoResponse.isError) {
          this.alertService.show('Erro', categoriaArquivoResponse.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Categoria alterada com sucesso.', AlertType.success);
        this.router.navigate(['/desenvolvedor/categoria-arquivo']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }
}
